<template>
  <div>
    <div class="datepickerwrap card">
      <div class="d-flex gap-3 tw-justify-between tw-items-center">
        <div class="tw-flex tw-gap-3 flex-wrap tw-items-center">
          <div style="min-width: 100px" >
            <div class="mb-1 ml-1 label">
              {{ translatedLang["Date Range"][selectedLanguage.key] }}
            </div>
            <date-range-picker
              v-model="dateRange"
              :show-dropdowns="true"
              opens="right"
              :autoApply="true"
              :locale-data="{ format: 'dd mmm yyyy' }"
              :min-date="minDate"
              :max-date="maxDate"
              :ranges="false"
              @update="getFiltersData()"
            >
            </date-range-picker>
          </div>
          <div
            class="customMultiselectCommon"
            style="min-width: 100px; max-width: 200px"
          >
            <div class="mb-1 ml-1 label">
              {{ translatedLang["Platform"][selectedLanguage.key] }}
            </div>
            <div>
              <multiselect
                v-model="selectedPlatform"
                :options="platforms"
                :multiple="false"
                :searchable="false"
                placeholder="Select Platform"
                label="value"
                track-by="key"
                :showLabels="false"
                :close-on-select="false"
                class="text-capitalize"
                @input="handleChangePlatform"
              >
              </multiselect>
            </div>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 100px; max-width: 200px"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Category"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="selectedCategory"
              class="text-capitalize"
              :options="categoryList"
              track-by="key"
              label="value"
              :multiple="false"
              :searchable="false"
              placeholder="Select Category"
              :showLabels="false"
              :close-on-select="true"
              :allow-empty="true"
            >
            </multiselect>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 100px; max-width: 200px"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Sub Category"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="selectedSubCategory"
              class="text-capitalize"
              :options="subCategoryList"
              track-by="key"
              label="value"
              :multiple="false"
              :searchable="false"
              placeholder="Select Sub Category"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
            >
            </multiselect>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 100px; max-width: 200px"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Brand"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="selectedOrderSummaryBrand"
              :options="brandList"
              :multiple="true"
              :searchable="false"
              placeholder="Select Brand"
              label="value"
              track-by="key"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="false"
              class="text-capitalize"
            >
              <template #option="{ option }">
                <input
                  type="checkbox"
                  :value="option"
                  v-model="selectedOrderSummaryBrand"
                />
                <span class="option__title ml-3 text-capitalize">{{
                  option.value
                }}</span>
              </template>
            </multiselect>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 100px; max-width: 200px"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Batch - Time"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="lossSelectedBatch"
              class="text-capitalize"
              :options="lossBatchList"
              track-by="batch"
              label="displayname"
              :multiple="false"
              :searchable="false"
              placeholder="Select Batch"
              :showLabels="false"
              :close-on-select="true"
              :allow-empty="true"
            >
              <template #option="{ option }">
                <span class="option__title ml-3 text-capitalize">{{
                  option.displayname.replaceAll("_", " ")
                }}</span>
              </template>
              <template #singleLabel="{ option }">
                {{ option.displayname.replaceAll("_", " ") }}
              </template>
            </multiselect>
          </div>
          <div class="tw-mt-5">
            <button class="btn primarycolor" @click="handleApplyFilter">
              Apply Filters
            </button>
          </div>
        </div>
        <div
          class="tw-text-primary_brand tw-font-[500] w-text-[14px] tw-cursor-pointer mt-2"
          @click="handleBack"
        >
          Back
        </div>
      </div>
    </div>
    <div class="card">
      <p
        class="tw-text-primary_brand tw-font-[500] tw-text-[16px] tw-py-4 tw-border-0 tw-border-b-[1px] tw-border-b-[#d4d4d4]"
      >
        Overall Brand Summary
      </p>
      <div class="tw-flex tw-gap-4" id="comparisonLineChart">
        <div
          v-if="paidLineChartData.seriesData.length"
          class="tw-border-[1px] tw-border-[#D4D4D4] tw-rounded-[10px] tw-w-[50%] tw-px-4 tw-pb-3"
        >
          <p
            class="tw-text-primary_brand tw-py-4 tw-font-[500] tw-text-[16px] tw-border-0 tw-border-b-[1px] tw-border-b-[#d4d4d4]"
          >
            Overall Brand Paid SOS
          </p>
          <lineChart :data="paidLineChartData" :key="Date.now() + 'data'" />
        </div>
        <div v-else>
          <NoData :loaderVariable="paidOrganicDataLoader" />
        </div>
        <div
          v-if="organicLineChartData.seriesData.length"
          class="tw-border-[1px] tw-border-[#D4D4D4] tw-px-4 tw-rounded-[10px] tw-w-[50%] tw-pb-4"
        >
          <p
            class="tw-text-primary_brand tw-py-4 tw-font-[500] tw-text-[16px] tw-border-0 tw-border-b-[1px] tw-border-b-[#d4d4d4]"
          >
            Overall Brand Orgainc SOS
          </p>
          <lineChart :data="organicLineChartData" :key="Date.now() + 'data'" />
        </div>
        <div v-else>
          <NoData :loaderVariable="paidOrganicDataLoader" />
        </div>
      </div>
    </div>
    <b-modal
      size="md"
      class="customModal"
      hide-footer
      style="z-index: 3000 !important; text-transform: capitalize"
      v-model="showViewModal"
      :title="viewModalName"
    >
      <div class="customMultiselect" v-if="viewModalName === 'Save View'">
        <multiselect
          v-model="selectedModalView"
          :options="modalViewOptions"
          :multiple="false"
          :searchable="false"
          placeholder="Select View"
          label="view_name"
          track-by="view_id"
          :showLabels="false"
          :close-on-select="true"
          :allow-empty="false"
        >
        </multiselect>
      </div>
      <input
        required
        type="text"
        v-model="newViewName"
        class="text-capitalize customInput px-2"
        v-show="
          viewModalName === 'Edit View' ||
          (viewModalName === 'Save View' &&
            selectedModalView.view_id === 'add_new')
        "
      />
      <div class="d-flex justify-content-end align-items-center mt-3">
        <button
          class="btn navigation-btn"
          :disabled="spinLoader"
          @click="saveCompareView"
        >
          <b-spinner small class="mr-2" v-if="spinLoader"></b-spinner>
          <span>{{ translatedLang["Save View"][selectedLanguage.key] }}</span>
        </button>
      </div>
    </b-modal>
    <b-modal
      title="Delete View"
      v-model="showDeleteModal"
      class="container-modal-ASIN"
    >
      <div class="modal-delete-content d-flex align-items-start mb-2">
        <div class="delete-alert text-center rounded-circle px-2 mr-3">
          &#9888;
        </div>
        <div>
          {{
            translatedLang["delete this View"][selectedLanguage.key]
          }}.<br />{{ translatedLang["Are you sure"][selectedLanguage.key] }} ?
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <b-button @click="showDeleteModal = false" class="btn primarycolor"
          >{{ translatedLang["No"][selectedLanguage.key] }},
          {{ translatedLang["Keep It"][selectedLanguage.key] }}.</b-button
        >
        <button
          @click="deleteView"
          :disabled="spinLoader"
          class="btn primarycolor px-3 py-1 ml-2 d-flex align-items-center delete-viewBtn"
          style="background-color: var(--red)"
        >
          <b-spinner small class="mr-2" v-if="spinLoader"></b-spinner>
          <span
            >{{ translatedLang["Yes"][selectedLanguage.key] }},
            {{ translatedLang["Delete"][selectedLanguage.key] }}!</span
          >
        </button>
      </div>
    </b-modal>
    <div class="card">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex justify-content-start mt-2" v-if="selectedView">
          <div class="graphHeading pb-2 mr-3">{{ selectedView.view_name }}</div>
          <div class="cursor-pointer" @click="openViewModal('Edit View')">
            <img
              src="../../../public/Icons_SVG/editBtn.svg"
              style="width: 15px; height: 15px"
            />
          </div>
          <div class="cursor-pointer ml-3" @click="showDeleteModal = true">
            <img
              src="../../../public/Icons_SVG/deleteBtnSvg.svg"
              style="width: 15px; height: 15px"
            />
          </div>
        </div>
        <div class="grayedHeading mt-2" v-else>
          {{ translatedLang["Unsaved View"][selectedLanguage.key] }}
        </div>
        <div class="d-flex justify-content-end align-items-end">
          <div style="margin-inline: 0.5rem">
            <div
              class="mb-1 ml-1"
              style="font-size: 14px; font-weight: 400; color: #1e1e1e"
            >
              {{ translatedLang["Select View Name"][selectedLanguage.key] }}
            </div>
            <div
              class="customMultiselect"
              style="width: 250px; margin-bottom: -5px"
            >
              <multiselect
                v-model="selectedView"
                :options="viewOptions"
                :multiple="false"
                :searchable="false"
                placeholder="Select View"
                label="view_name"
                track-by="view_id"
                :showLabels="false"
                :close-on-select="true"
                :allow-empty="false"
                @input="getSelectedSavedView"
              >
              </multiselect>
            </div>
          </div>
          <div class="d-flex align-items-end">
            <button
              @click="resetSavedView"
              class="btn primarycolor mr-2 d-flex item-items-center"
            >
              <span class="newComparisonIcon">
                <svg
                  focusable="false"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                  ></path>
                </svg>
              </span>
              <span>{{
                translatedLang["Add New View"][selectedLanguage.key]
              }}</span>
            </button>
          </div>
          <div class="d-flex justify-content-end align-items-center">
            <button
              class="btn navigation-btn"
              @click="openViewModal('Save View')"
            >
              <span>{{
                translatedLang["Save View"][selectedLanguage.key]
              }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="tw-flex tw-gap-4">
      <div
        id="comparisonLineChart"
        class="card tw-border-[1px] tw-border-[#d4d4d4] tw-w-[50%]"
      >
        <div>
          <p class="tw-text-primary_brand tw-text-[16px] tw-font-[500]">
            {{ selectedKeyword?.value }}
          </p>
          <p class="tw-text-[#5E5E5E] tw-text-[16px] tw-font-[400]">
            Primary Keyword
          </p>
          <div class="customMultiselectCommon">
            <div>
              <multiselect
                v-model="selectedKeyword"
                :options="keywordList"
                :multiple="false"
                :searchable="false"
                placeholder="Select Keyword"
                label="value"
                track-by="key"
                :showLabels="false"
                :close-on-select="true"
                :allow-empty="false"
                class="text-capitalize tw-my-2"
                @input="getCompareData((index = 0))"
              >
              </multiselect>
              <multiselect
                v-model="selectedBrand"
                :options="brandList"
                :multiple="true"
                :searchable="false"
                placeholder="Select Brand"
                label="value"
                track-by="key"
                :showLabels="false"
                :close-on-select="false"
                :allow-empty="false"
                class="text-capitalize"
                @input="getCompareData((index = 0))"
              >
                <template #option="{ option }">
                  <input
                    type="checkbox"
                    :value="option"
                    v-model="selectedBrand"
                  />
                  <span class="option__title ml-3 text-capitalize">{{
                    option.value
                  }}</span>
                </template>
              </multiselect>
            </div>
          </div>
        </div>
        <div
          class="tw-my-4 tw-border-[1px] tw-border-[#D4D4D4] tw-rounded-[10px] tw-w-full tw-px-4"
        >
          <p
            class="tw-text-primary_brand tw-py-4 tw-font-[500] tw-text-[16px] tw-border-0 tw-border-b-[1px] tw-border-b-[#d4d4d4]"
          >
            Paid SOS
          </p>
          <lineChart
            v-if="comparisonList.length && comparisonList[0]?.paidCompTrendline"
            :data="comparisonList[0].paidCompTrendline"
            :key="Date.now() + 'data'"
          />
        </div>
        <div
          class="tw-border-[1px] tw-border-[#D4D4D4] tw-px-4 tw-rounded-[10px] tw-w-full"
        >
          <p
            class="tw-text-primary_brand tw-py-4 tw-font-[500] tw-text-[16px] tw-border-0 tw-border-b-[1px] tw-border-b-[#d4d4d4]"
          >
            Orgainc SOS
          </p>
          <lineChart
            v-if="
              comparisonList.length && comparisonList[0]?.organicCompTrendline
            "
            :data="comparisonList[0].organicCompTrendline"
            :key="Date.now() + 'organicCompTrendline'"
          />
        </div>
      </div>
      <div
        v-if="isCompare"
        id="comparisonLineChart"
        class="card tw-border-[1px] tw-border-[#d4d4d4] tw-w-[50%]"
      >
        <div>
          <div class="tw-flex tw-justify-between">
            <div>
              <p class="tw-text-primary_brand tw-text-[16px] tw-font-[500]">
                {{ selectedCompKeyword?.value }}
              </p>
              <p class="tw-text-[#5E5E5E] tw-text-[16px] tw-font-[400]">
                Competitor Keyword
              </p>
            </div>
            <div>
              <img
                src="../../../public/Icons_SVG/close.svg"
                alt="Close"
                @click="isCompare = false"
                class="tw-cursor-pointer"
              />
            </div>
          </div>
          <div class="customMultiselectCommon">
            <div>
              <multiselect
                v-model="selectedCompKeyword"
                :options="keywordList"
                :multiple="false"
                :searchable="false"
                placeholder="Select Keyword"
                label="value"
                track-by="key"
                :showLabels="false"
                :close-on-select="true"
                :allow-empty="false"
                class="text-capitalize tw-my-2"
                @input="getCompareData((index = 1))"
              >
              </multiselect>
              <multiselect
                v-model="selectedCompBrand"
                :options="brandList"
                :multiple="true"
                :searchable="false"
                placeholder="Select Brand"
                label="value"
                track-by="key"
                :showLabels="false"
                :close-on-select="false"
                :allow-empty="false"
                class="text-capitalize"
                @input="getCompareData((index = 1))"
              >
                <template #option="{ option }">
                  <input
                    type="checkbox"
                    :value="option"
                    v-model="selectedCompBrand"
                  />
                  <span class="option__title ml-3 text-capitalize">{{
                    option.value
                  }}</span>
                </template>
              </multiselect>
            </div>
          </div>
          <div
            v-if="comparisonList.length && comparisonList[1]?.paidCompTrendline"
            class="tw-my-4 tw-border-[1px] tw-border-[#D4D4D4] tw-rounded-[10px] tw-w-full tw-px-4 !tw-pb-10"
          >
            <p
              class="tw-text-primary_brand tw-py-4 tw-font-[500] tw-text-[16px] tw-border-0 tw-border-b-[1px] tw-border-b-[#d4d4d4]"
            >
              Paid SOS
            </p>
            <lineChart
              :data="comparisonList[1].paidCompTrendline"
              :key="Date.now() + 'data'"
            />
          </div>
          <div
            v-if="
              comparisonList.length && comparisonList[1]?.organicCompTrendline
            "
            class="tw-border-[1px] tw-border-[#D4D4D4] tw-px-4 tw-rounded-[10px] tw-w-full tw-pb-2"
          >
            <p
              class="tw-text-primary_brand tw-py-4 tw-font-[500] tw-text-[16px] tw-border-0 tw-border-b-[1px] tw-border-b-[#d4d4d4]"
            >
              Orgainc SOS
            </p>
            <lineChart
              :data="comparisonList[1].organicCompTrendline"
              :key="Date.now() + 'organicCompTrendline1'"
            />
          </div>
        </div>
      </div>
      <div v-if="!isCompare" class="d-flex" style="min-width: 45%">
        <div class="add-comparison mx-1 w-100">
          <div class="plus-icon" @click="prepareComparisonList">+</div>
          <div style="font-size: 16px; font-weight: 500">
            {{ translatedLang["Add Keyword"][selectedLanguage.key] }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import Multiselect from "vue-multiselect";
import lineChart from "../commonCharts/lineChart.vue";
import { mapState, mapActions } from "vuex";
import NoData from "../Components/noData.vue";

export default {
  name: "SOS Compare",
  components: {
    Multiselect,
    lineChart,
  },
  data() {
    return {
      dateRange: {
        startDate: moment().subtract(2, "week").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      maxDate: new Date(),
      minDate: new Date(moment().subtract(3, "years")),
      platforms: [],
      selectedPlatform: "",
      viewModalTrendLineData: [],
      organicLineChartData: {},
      paidLineChartData: {},
      comparisonList: [
        {
          storePaidTrendlineData: [],
          paidCompTrendline: null,
          storeOrganicTrendlineData: [],
          organicCompTrendline: null,
        },
      ],
      allKeywordList: [],
      selectedKeyword: "",
      selectedCompKeyword: "",
      keywordList: [],
      selectedBrand: [],
      selectedCompBrand: [],
      brandList: [],
      isCompare: false,
      categoryList: [],
      allCategory: [],
      selectedCategory: "",
      subCategoryList: [],
      selectedSubCategory: "",
      selectedOrderSummaryBrand: [],
      savedViews: [],
      viewOptions: [],
      selectedView: "",
      showViewModal: false,
      viewModalName: "",
      selectedModalView: {
        view_id: "add_new",
        view_name: "Add New",
      },
      newViewName: "",
      spinLoader: false,
      lossSelectedBatch: [],
      lossBatchList: [],
      paidOrganicDataLoader: false,
      showDeleteModal: false,
      featureId: JSON.parse(localStorage.reviewUserData).data.feature_id_map.Share_Of_Search,
    };
  },
  computed: {
    ...mapState("DemoStore", ["selectedLanguage", "translatedLang"]),
  },
  mounted() {
    this.getFiltersData();
    this.getSavedViews();
  },
  watch: {
    selectedCategory(newVal) {
      this.subCategoryList = newVal.child;
      this.selectedSubCategory = this.subCategoryList[0];
    },
  },
  methods: {
    ...mapActions("DemoStore", [
      "setSelectedLanguage",
      "initializeTranslation",
    ]),
    
    prepareComparisonList() {
      this.selectedCompBrand = [];
      if (this.comparisonList.length) {
        this.comparisonList.push({
          storePaidTrendlineData: [],
          paidCompTrendline: null,
          storeOrganicTrendlineData: [],
          organicCompTrendline: null,
        });
      }
      this.isCompare = true;
    },
    handleChangePlatform() {
      this.keywordList = this.allKeywordList[this.selectedPlatform.key];
      this.selectedKeyword = this.keywordList[0];
      this.selectedCompKeyword = this.keywordList[0];
      this.categoryList = this.allCategory[this.selectedPlatform.key];
      this.selectedCategory = this.categoryList[0];
      this.getCompareData();
    },
    handleApplyFilter() {
      this.getPaidOrganicData();
    },
    handleBack() {
      this.$router.back();
    },
    goToProductSentiments() {
      localStorage.setItem("compareProducts", true);
      if (this.selectedView) {
        localStorage.setItem("savedView", this.selectedView.view_id);
      }
      this.$nextTick(() => {
        this.$router.push("/sentiment/product");
      });
    },
    openViewModal(viewType) {
      this.modalViewOptions = [
        ...this.viewOptions,
        {
          view_id: "add_new",
          view_name: "Add New",
        },
      ];

      if (viewType === "Edit View") {
        this.newViewName = this.selectedView.view_name;
      } else if (viewType === "Save View") {
        this.selectedModalView = {
          view_id: "add_new",
          view_name: "Add New",
        };

        this.newViewName = "";
      }

      this.$nextTick(() => {
        this.viewModalName = viewType;
        this.showViewModal = true;
      });
    },
    getSavedViews() {
      this.savedViews = [];
      this.viewOptions = [];
      const url =
        "/api/v2/reviews/comparison_view?view_for=keyword_reviews_compare";

      this.$http
        .get(url)
        .then((res) => {
          this.savedViews = res.data.data;
          if (this.savedViews.length) {
            this.savedViews.map((view) => {
              this.viewOptions.push({
                view_id: view.view_id,
                view_name: view.view_name,
              });
            });
          }

          if (localStorage.savedView) {
            this.selectedView = this.viewOptions.find(
              (view) => view.view_id === localStorage.savedView
            );
            localStorage.removeItem("savedView");
            this.$nextTick(() => {
              this.getSelectedSavedView();
            });
          }

          if (
            this.viewModalName === "Edit View" ||
            (this.viewModalName === "Save View" &&
              this.selectedModalView.view_id === "add_new")
          ) {
            this.selectedView = this.viewOptions.find(
              (view) => view.view_name === this.newViewName
            );
            this.resetViewModal();
          } else this.resetViewModal();
        })
        .catch((err) => {
          console.log(`Error getting saved views:: ${err}`);
        });
    },
    resetViewModal() {
      this.viewModalName = "";
      this.newViewName = "";
      this.modalViewOptions = [];
      this.showViewModal = false;
    },
    getSelectedSavedView() {
      this.savedViewLoader = true;
      this.comparisonList = [];
      this.getBrandImage();

      const targetView = this.savedViews.find(
        (view) => view.view_id === this.selectedView.view_id
      );

      this.dateRange = targetView.page_filter.dateRange;
      this.selectedPlatform = targetView.page_filter.selectedPlatform;
      this.selectedCategory = targetView.page_filter.selectedCategory;

      const compareBrandPayload = [];

      targetView.product_filter.map((brand, index) => {
        this.comparisonList.push({
          selectedProduct: [`${brand.selectedBrand}+${brand.selectedProduct}`],
          ratingsData: {},
          sentiments: [],
          currentTab: "Sentiment Overview",
          img: "",
          viewModalTrendLineData: [],
          trendlineData: null,
          barGraphData: null,
          multiTrendLineData: null,
        });

        compareBrandPayload.push({
          brand_name: brand.selectedBrand,
          category_name: this.selectedSubCategory.key,
          product_id: brand.selectedProduct,
        });
      });

      this.$nextTick(() => {
        const url = "/api/v2/boat/review_compare";
        // const url = "/api/v2/indian_clients/compare_data";
        const payload = {
          start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
          end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
          client: this.client,
          channel: [this.selectedPlatform.platform_name],
          brand: compareBrandPayload.map((brand) => brand.brand_name),
          product: compareBrandPayload.map((product) => product.product_id),
          // compare_type: "product",
          save_view: true,
          is_product: true,
          language: this.$store.state.DemoStore.selectedLanguage.key,
        };

        this.reviewLoader = true;

        this.$http
          .post(url, payload)
          .then((res) => {
            this.reviewLoader = false;
            this.savedViewLoader = false;
            this.comparisonList.forEach((brand, index) => {
              const productName = brand.selectedProduct[0].split("+")[1];

              this.comparisonList[index].ratingsData =
                res.body.data[productName].ratings;

              this.comparisonList[index].viewModalTrendLineData =
                res.body.data[productName].performance[
                  this.reviewLineChartInterval
                ];
              this.processReviewTrendlineGraph(index);
              // this.comparisonList[index].sentiments =
              //   res.body.data[productName].sentiment;
              // this.comparisonList[index].img =
              //   res.body.data[productName].product_image;
            });
            // console.log("this.comparisonList", this.comparisonList);

            this.$nextTick(() => {
              this.getVoiceOfCustomer();
              this.getReviewCount();
            });
          })
          .catch((err) => {
            this.reviewLoader = false;
            console.log("Error in getting compare brand data", err);
          });
        this.savedViewLoader = false;
      });
    },
    saveCompareView() {
      if (this.viewModalName === "Edit View" && !this.newViewName) {
        this.$bvToast.toast("Please provide a name to edit this view", {
          title: "Edit View",
          variant: "danger",
          solid: true,
          toaster: "b-toaster-top-right",
          autoHideDelay: 2000,
          appendToast: true,
        });
        return;
      } else if (
        this.selectedModalView.view_id === "add_new" &&
        !this.newViewName
      ) {
        this.$bvToast.toast("Please provide a name to save new view", {
          title: "Save View",
          variant: "danger",
          solid: true,
          toaster: "b-toaster-top-right",
          autoHideDelay: 2000,
          appendToast: true,
        });
        return;
      }

      this.spinLoader = true;

      if (this.newViewName) {
        let capitalizedText;
        capitalizedText = this.newViewName
          .split(" ")
          .map(
            (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
          )
          .join(" ");

        this.newViewName = capitalizedText;
      }

      const url = "/api/v2/reviews/comparison_view";
      let payload = {
        view_for: "keyword_reviews_compare",
        view_data: {
          page_filter: {
            dateRange: {
              startDate: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
              endDate: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
            },
            selectedPlatform: this.selectedPlatform,
            selectedCategory: this.selectedSubCategory,
          },
          product_filter: this.comparisonList.map((compareProduct) => {
            return {
              selectedBrand: "test",
              selectedProduct: "test",
            };
          }),
          view_name: this.newViewName,
        },
      };

      if (this.viewModalName === "Edit View") {
        payload = {
          ...payload,
          view_id: this.selectedView.view_id,
        };
      }

      if (
        this.viewModalName === "Save View" &&
        this.selectedModalView.view_id !== "add_new"
      ) {
        (payload.view_data.view_name = this.selectedModalView.view_name),
          (payload = {
            ...payload,
            view_id: this.selectedModalView.view_id,
          });
      }

      this.$http
        .post(url, payload)
        .then((res) => {
          this.getSavedViews();
          this.spinLoader = false;
        })
        .catch((err) => {
          console.log(`Error in saving view::${err}`);
          this.spinLoader = false;
        });
    },
    resetSavedView() {
      this.selectedView = "";
      this.resetComparisonList();
    },
    deleteView() {
      const url = "/api/v2/reviews/comparison_view";
      let payload = {
        view_id: [this.selectedView.view_id],
        view_for: "keyword_reviews_compare",
      };

      this.spinLoader = true;
      this.$http
        .delete(url, { body: payload })
        .then((res) => {
          this.getSavedViews();
          this.resetSavedView();

          this.$bvToast.toast("View deleted successfully", {
            title: "Delete View",
            variant: "success",
            solid: true,
            toaster: "b-toaster-top-right",
            autoHideDelay: 2000,
            appendToast: true,
          });

          this.spinLoader = false;
        })
        .catch((err) => {
          console.log(err);
          // this.$bvToast.toast("Error in deleting this view", {
          //   title: "Delete View",
          //   variant: "danger",
          //   solid: true,
          //   toaster: "b-toaster-top-right",
          //   autoHideDelay: 2000,
          //   appendToast: true,
          // });
          this.spinLoader = false;
        });

      this.showDeleteModal = false;
    },
    getFiltersData() {
      const url = "/api/v2/product/filter_data";
      let payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        language: this.$store.state.DemoStore.selectedLanguage.key,
        feature_id: this.featureId,
      };
      this.$http
        .post(url, payload)
        .then((res) => {
          this.platforms = res.data.data.platform;
          this.selectedPlatform = this.platforms[0];
          this.allKeywordList = res.data.data.search;
          this.keywordList = this.allKeywordList[this.selectedPlatform.key];
          this.selectedKeyword = this.keywordList[0];
          this.selectedCompKeyword = this.keywordList[0];
          this.allCategory = res.data.data.category;
          this.categoryList = this.allCategory[this.selectedPlatform.key];
          this.selectedCategory = this.categoryList[0];
          this.lossBatchList = res.data.data.batch["share of search"];
          this.lossSelectedBatch = this.lossBatchList[0];
          this.getBrandData();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getBrandData() {
      const url = "/api/v2/brand/data";
      let payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        language: "en",
        channel: [this.selectedPlatform.key],
        category: this.selectedSubCategory
          ? [this.selectedSubCategory.key]
          : [],
        pincode: [],
        feature_id: this.featureId,
      };
      this.$http
        .post(url, payload)
        .then((res) => {
          this.brandList = res.data.data;
          this.selectedBrand = [...this.brandList.slice(0, 4)];
          this.selectedOrderSummaryBrand = [...this.brandList.slice(0, 4)];
          this.getPaidOrganicData();
          this.getCompareData(0);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getPaidOrganicData() {
      this.paidOrganicDataLoader = true;
      const url = "/api/v2/sos_comparison_keyword";

      let payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        batch: [this.lossSelectedBatch.batch],
        channel: [this.selectedPlatform.key],
        brands: this.selectedOrderSummaryBrand.map((brand) => brand.key),
        feature_id: this.featureId,
      };

      this.$http
        .post(url, payload)
        .then((res) => {
          this.viewModalTrendLineData = res.data.data;
          this.processOrganicLineChart();
          this.processPaidLineChart();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getCompareData(index = 0) {
      const url = "/api/v2/sos_comparison_keyword";

      let payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        batch: [this.lossSelectedBatch.batch],
        channel: [this.selectedPlatform.key],
        brands:
          index == 0
            ? this.selectedBrand.map((brand) => brand.key)
            : this.selectedCompBrand.map((brand) => brand.key),
        keyword:
          index == 0
            ? [this.selectedKeyword.key]
            : [this.selectedCompKeyword.key],
        feature_id: this.featureId,
      };

      this.$http
        .post(url, payload)
        .then((res) => {
          this.comparisonList[index].storePaidTrendlineData =
            res.data.data.paid;
          this.comparisonList[index].storeOrganicTrendlineData =
            res.data.data.organic;
          this.processCompPaidLineChart(index);
          this.processCompOrganicLineChart(index);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    processOrganicLineChart() {
      this.organicLineChartData = {};

      const performance = this.viewModalTrendLineData.organic;

      if (!performance || performance.length === 0) return;

      const xAxisData = performance?.map((item) =>
        moment(item.date).format("D MMM")
      );
      const starCategories = Object.keys(performance[0]).filter(
        (data) => data != "date"
      );
      const colorList = ["#B91C1C", "#46A493", "#F9B429", "#0463BA", "#065559"];

      const seriesData = starCategories?.map((star, idx) => ({
        name: star,
        color: colorList[idx],
        marker: {
          enabled: true,
          lineWidth: 3,
          fillColor: "#fff",
          lineColor: colorList[idx],
          radius: 4,
          symbol: "circle",
        },
        dataLabels: {
          enabled: false,
          allowOverlap: true,
          style: { fontWeight: "normal" },
          formatter() {
            return "₹" + this.point.y.toLocaleString();
          },
        },
        data: performance.map((item) => item[star]),
      }));

      this.organicLineChartData = {
        id: `reviewTrendlineGraph-${Date.now()}`,
        marginTop: 96,
        xAxis: xAxisData,
        seriesData: seriesData,
      };
    },
    processPaidLineChart() {
      this.paidLineChartData = {};

      const performance = this.viewModalTrendLineData.paid;

      if (!performance || performance.length === 0) return;

      const xAxisData = performance?.map((item) =>
        moment(item.date).format("D MMM")
      );
      const starCategories = Object.keys(performance[0]).filter(
        (data) => data != "date"
      );
      const colorList = ["#B91C1C", "#46A493", "#F9B429", "#0463BA", "#065559"];

      const seriesData = starCategories?.map((star, idx) => ({
        name: star,
        color: colorList[idx],
        marker: {
          enabled: true,
          lineWidth: 3,
          fillColor: "#fff",
          lineColor: colorList[idx],
          radius: 4,
          symbol: "circle",
        },
        dataLabels: {
          enabled: false,
          allowOverlap: true,
          style: { fontWeight: "normal" },
          formatter() {
            return "₹" + this.point.y.toLocaleString();
          },
        },
        data: performance.map((item) => item[star]),
      }));

      this.paidLineChartData = {
        id: `processPaidLineChart-${Date.now()}`,
        // marginTop: ,
        marginTop: 96,
        xAxis: xAxisData,
        seriesData: seriesData,
      };
    },
    processCompPaidLineChart(index) {
      this.comparisonList[index].paidCompTrendline = {};

      const performance = this.comparisonList[index].storePaidTrendlineData;

      if (!performance || performance.length === 0) return;

      const xAxisData = performance?.map((item) =>
        moment(item.date).format("D MMM")
      );
      const starCategories = Object.keys(performance[0]).filter(
        (data) => data != "date"
      );
      const colorList = ["#B91C1C", "#46A493", "#F9B429", "#0463BA", "#065559"];

      const seriesData = starCategories?.map((star, idx) => ({
        name: star,
        color: colorList[idx],
        marker: {
          enabled: true,
          lineWidth: 3,
          fillColor: "#fff",
          lineColor: colorList[idx],
          radius: 4,
          symbol: "circle",
        },
        dataLabels: {
          enabled: false,
          allowOverlap: true,
          style: { fontWeight: "normal" },
          formatter() {
            return "₹" + this.point.y.toLocaleString();
          },
        },
        data: performance.map((item) => item[star]),
      }));

      this.comparisonList[index].paidCompTrendline = {
        id: `paidCompTrendline-${Date.now()}`,
        marginTop: 96,
        xAxis: xAxisData,
        seriesData: seriesData,
      };
    },
    processCompOrganicLineChart(index) {
      this.comparisonList[index].organicCompTrendline = {};

      const performance = this.comparisonList[index].storeOrganicTrendlineData;

      if (!performance || performance.length === 0) return;

      const xAxisData = performance?.map((item) =>
        moment(item.date).format("D MMM")
      );
      const starCategories = Object.keys(performance[0]).filter(
        (data) => data != "date"
      );
      const colorList = ["#B91C1C", "#46A493", "#F9B429", "#0463BA", "#065559"];

      const seriesData = starCategories?.map((star, idx) => ({
        name: star,
        color: colorList[idx],
        marker: {
          enabled: true,
          lineWidth: 3,
          fillColor: "#fff",
          lineColor: colorList[idx],
          radius: 4,
          symbol: "circle",
        },
        dataLabels: {
          enabled: false,
          allowOverlap: true,
          style: { fontWeight: "normal" },
          formatter() {
            return "₹" + this.point.y.toLocaleString();
          },
        },
        data: performance.map((item) => item[star]),
      }));

      this.comparisonList[index].organicCompTrendline = {
        id: `organicCompTrendline-${Date.now()}`,
        xAxis: xAxisData,
        seriesData: seriesData,
      };
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem;
}

.add-comparison {
  border: 1px solid #d9d9d9;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  height: 200px;
  border-radius: 10px;
  color: #5e5e5e;
}

.plus-icon {
  font-size: 30px;
  color: #5e5e5e;
  border: 2px dashed #5e5e5e;
  border-radius: 50%;
  padding-inline: 12px;
  cursor: pointer;
}

button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 7px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 14px;
}

button.navigation-btn {
  background: var(--accent_color);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 7px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 14px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
  /* border: 1.6px solid var(--base_color); */
}

button.navigation-btn:hover {
  background: var(--accent_color-80);
}
.customInput {
  border-radius: 5px !important;
  height: 35px !important;
  border: 1px solid #e4e7ea;
  width: 220px;
  outline: none;
  font-family: "poppins";
  width: 100%;
}

.customInput:focus {
  border: 1px solid var(--primary_brand) !important;
  box-shadow: none !important;
}
</style>
<style>
#comparisonLineChart .highcharts-root {
  /* height: 450px !important; */
}
#comparisonLineChart .highcharts-container {
  /* height: 450px !important; */
}
</style>
